import { render, staticRenderFns } from "./ModalMostrarPlanPagoUniversidad.vue?vue&type=template&id=85ac07fc"
import script from "./ModalMostrarPlanPagoUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalMostrarPlanPagoUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports